import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { useData } from '../../../contexts/DataContext';

export default function Compontent({ items }) {
  const navigate = useNavigate();
  const data = useData();

  function handleEdit(id) {
    navigate('/loan/' + id);
  }

  const getStatusBadge = (status) => {
    const label =
      status == 'pending' || !status
        ? 'Pendente'
        : status == 'paid'
        ? 'Pago'
        : status == 'parcial'
        ? 'Parcialmente'
        : 'Atrasado';

    const color =
      status == 'paid'
        ? 'bg-green-200 text-green-900'
        : status == 'pending' || !status || status == 'parcial'
        ? 'bg-amber-200 text-amber-900'
        : 'bg-red-200 text-red-900';

    return { label, color };
  };

  return (
    <div className="w-full overflow-x-auto rounded-xl border border-slate-200 bg-white">
      <table className="w-full table-auto border-collapse text-sm">
        <thead>
          <tr className="border-b border-slate-200 bg-slate-50">
            <th className="whitespace-nowrap px-3 py-2.5 text-left text-xs font-semibold uppercase tracking-wider text-slate-500">
              Cliente
            </th>
            <th className="whitespace-nowrap px-3 py-2.5 text-left text-xs font-semibold uppercase tracking-wider text-slate-500">
              Montante
            </th>
            <th className="whitespace-nowrap px-3 py-2.5 text-left text-xs font-semibold uppercase tracking-wider text-slate-500">
              Dias em falta
            </th>
            <th className="whitespace-nowrap px-3 py-2.5 text-left text-xs font-semibold uppercase tracking-wider text-slate-500">
              Vencimento
            </th>
            <th className="whitespace-nowrap px-3 py-2.5 text-left text-xs font-semibold uppercase tracking-wider text-slate-500">
              Estado
            </th>
          </tr>
        </thead>

        <tbody className="divide-y divide-slate-100">
          {items.map((i) => {
            const { label, color } = getStatusBadge(i.status);

            return (
              <tr
                key={i.contract_id}
                onClick={() => handleEdit(i.contract_id)}
                className="cursor-pointer transition hover:bg-slate-50"
              >
                <td className="whitespace-nowrap px-3 py-2.5 text-slate-700">
                  {i.client.name}
                </td>
                <td className="whitespace-nowrap px-3 py-2.5 text-slate-700">
                  {data._cn((i.total_to_pay - i.paid).toFixed(2))}
                </td>
                <td className="whitespace-nowrap px-3 py-2.5 text-slate-700">
                  {i.remaining_days == 0
                    ? 'Hoje'
                    : i.remaining_days < 0
                    ? -i.remaining_days + ' dias atrás'
                    : i.remaining_days}
                </td>
                <td className="whitespace-nowrap px-3 py-2.5 text-slate-700">
                  {i.end?.split('-')?.reverse()?.join('/')}
                </td>
                <td className="whitespace-nowrap px-3 py-2.5">
                  <span
                    className={`inline-flex items-center justify-center whitespace-nowrap rounded-full px-3 py-0.5 text-xs font-medium ${color}`}
                  >
                    {label}
                  </span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      {!items.length && (
        <span className="flex items-center justify-center p-8 text-sm text-slate-400">
          Sem registros
        </span>
      )}
    </div>
  );
}